import { LoadingLoop } from '@medeloop/medeloop-components-library';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authenticateUser } from 'src/api/auth';
import { configuration } from 'src/configuration';

import { removeAuthCookies, setAuthCookies } from 'src/utils/cookies';
import { safeRedirect } from 'src/utils/safe-redirect';

export function CallbackElement() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthentication = async () => {
      try {

        const redirectUrl = localStorage.getItem('redirect_url') || configuration.appUrl;
        const clientId =
          new URLSearchParams(location.search).get('client_id') || configuration.cognitoClientId;
        const code = new URLSearchParams(location.search).get('code');

        const error_description = new URLSearchParams(location.search).get('error_description');
        if (error_description) {
          // Handle SSO errors
          console.error('[SSO Callback] SSO error:', error_description);
          navigate(
            `${configuration.loginAppUrl}/sign-in?error=SSO_error&redirect_url=${redirectUrl}`,
            { replace: true },
          );
          return;
        }

        if (!code) {
          removeAuthCookies();
          navigate(
            `${configuration.loginAppUrl}/sign-in?error=SSO_error&redirect_url=${redirectUrl}`,
            { replace: true },
          );
          return;
        }

        const { refresh_token } = await authenticateUser(code);

        setAuthCookies(clientId || '', refresh_token);
        safeRedirect(redirectUrl);
      } catch (error) {
        navigate(`${configuration.loginAppUrl}/sign-in?error=SSO_error`, { replace: true });
      }
    };

    handleAuthentication();
  }, []);

  return (
    <div className="flex flex-1 items-center justify-center">
      <LoadingLoop className="w-16" />
    </div>
  );
}
